import {environment} from '../../environments/environment';
import { Injectable } from "@angular/core";

@Injectable()
export class ApiRoutes {
  readonly LOGIN: string = environment.apiUrl + 'api/token/requestToken';
  readonly LOGOUT: string = environment.apiUrl + 'api/account/logout';
  readonly TRUST_BROWSER = environment.apiUrl + 'api/account/trust-browser';
  readonly APPLICATIONS: string = environment.apiUrl + 'api/applications';
  readonly APPLICATIONS_ADD: string = environment.apiUrl + 'api/applications/add/{0}';
  readonly ERROR_LOG: string = environment.apiUrl + 'api/errorHandling';
  readonly FORGOT_PASSWORD: string = environment.apiUrl + 'api/account/forgotPassword';
  readonly CONFIRM_FORGOT_PASSWORD: string = environment.apiUrl + 'api/account/setPassword';
  readonly CONFIRM_ACCOUNT: string = environment.apiUrl + 'api/account/Confirm/';
  readonly CONFIRM_ACCOUNT_DELETION: string = environment.apiUrl + 'api/account/delete';
  readonly LICENSE: string = environment.apiUrl + 'api/account/licenseagreement/{0}';
  readonly ACCEPT_LICENSE: string = environment.apiUrl + 'api/account/licenseagreement/accept';

  public getRouteWithInjectedParams(route: string, values: string[]): string {
    let result: string = route;
    for (let i = 0; i < values.length; i++) {
      result = result.replace(`{${i}}`, values[i]);
    }
    return result;
  }
}
